<div
  class="item-card row cursor-pointer {{ item().status }}"
  [ngClass]="{ isOverDue: item().isOverDue }"
  (click)="openItemEditModal(item().id, item().itemKey, item().boardKey)"
>
  <div class="{{ isSimpleMode() ? 'col-12 text-center' : 'col-9' }} left-side">
    <div class="{{ isSimpleMode() ? 'icon-center' : 'icon' }}">
      <app-inline-user-chip
        [name]="item().assigneeName!"
        [boardId]="item().boardId"
        [itemId]="item().id"
        (triggerRefresh)="triggerRefresh()"
        (click)="$event.stopPropagation()"
        ><app-text-avatar [text]="item().assigneeName!"></app-text-avatar
      ></app-inline-user-chip>
    </div>
    <div class="title f-12" *ngIf="!isSimpleMode()">{{ item().title }}</div>
    <div class="subtitle f-10">{{ item().itemKey }}</div>
  </div>
  <div class="{{ isSimpleMode() ? 'col-12 text-center' : 'col-3 text-right' }}">
    <button mat-icon-button (click)="onStatusChange($event)" matTooltip="{{ 'filterCard.status' | translate }}">
      <mat-icon>sync</mat-icon>
    </button>
  </div>
</div>
